<template>
  <div>
    <h2>Заявка на заморозку абонемента</h2>
    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Beatae dignissimos enim et eveniet expedita fugiat totam! Eveniet fuga illum ipsum modi necessitatibus officia? Blanditiis consequatur, ea iusto nesciunt nulla repudiandae?</p>
  </div>
</template>

<script>
export default {
  name: "freeze_order",
  data() {
    return {}
  },
  props: {
    items: ''
  },
  methods: {}
}
</script>

<style scoped>

</style>